<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <Tab :data="tabData" :tabIdx="tabIdx" @onToggleTab="onToggleTab" />

    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <template #start>
        <el-form-item class="startBtn">
          <el-button type="primary" @click="generatProfit">生成利润</el-button>
        </el-form-item>
      </template>
      <template #end>
        <el-form-item class="endBtn">
          <!-- 导出按钮 -->
          <el-button type="primary" icon="el-icon-download" @click="Export(`${fleetName}车队利润表`)">导出</el-button>
        </el-form-item>
      </template>
    </SearchField>

    <Table ref="table" :tableHeight="tableHeight" :tableData="tableData" :cols="cols" :btns="btns" :page="page"
      :limit="limit" :total="total" :showIndex="true" :showTotal="true" :getTotal="getTotal"
      @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange" @onSizeChange="onSizeChange" />

    <Dialog class="dialog" ref="dialog" :title="title" @closed="dialogClosed" :width="'940px'">
      <template #default>
        <el-form class="searchForm" :model="modalSearchForm">
          <el-checkbox class="checkAll" :indeterminate="isIndeterminate" v-model="checkAll"
            @change="handleCheckAllChange">全选
          </el-checkbox>

          <FormItem v-for="(c, i) in modalSearchFormCtrl" :key="'msformItem' + i" :viewMode="false" :config="c"
            :options="c.options" :inputValue="modalSearchForm[c.keyName]" @onChange="onModalSearchFormChange" />
        </el-form>

        <el-scrollbar class="content-h">
          <el-checkbox-group class="list" v-model="checkedIds" @change="onCheckChange">
            <el-checkbox class="item" v-for="(c, i) in modalList" :key="'itemm' + i" :label="c.license">
              <!--<div class="row0">{{ c.license }}-{{ c.driver }}</div>-->
              <div class="basic">
                <span>{{ c.license }}</span><span>{{ c.driver }}</span>
              </div>
              <!--<div class="row1">
                <div class="label">出勤天数</div>
                <div class="content">
                  <input type="text" v-model="c.unattendance" readonly>
                  <div class="unit">天</div>
                </div>
              </div>-->
              <div class="sel">
                <span>出勤<input type="text" v-model="c.unattendance" readonly>天</span>
              </div>
            </el-checkbox>
          </el-checkbox-group>
        </el-scrollbar>

        <div class="btns">
          <el-button type="primary" @click="onModalSubmit">确 定</el-button>
          <el-button @click="hideDialog">取 消</el-button>
        </div>
      </template>
    </Dialog>
  </div>
</template>

<script>
import tableMixin from "../../mixin/table";

export default {
  name: "FinanceEstimatedProfit",
  mixins: [tableMixin],
  data() {
    return {
      baseUrl: 'money',
      breadcrumb: [
        { name: "财务管理" },
        { name: "车队利润表" },
      ],
      tabIdx: 0,
      tabData: [],
      menu: [],
      team: [],
      formInline: {
        license: '',
        month: '',
      },
      formCtrl: [
        {
          ...this.ctrls.license,
          label: '车牌号',
        },
        {
          ...this.ctrls.month,
        },
      ],
      cols: [
        { prop: "month", label: "月份" },
        { prop: "license", label: "车牌号", minwidth: 120 },
        { prop: "infreight", label: "运费总额", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "basemoney", label: "司机工资", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "escort", label: "押运员工资", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "unattendance", label: "出勤天数", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "gomoney", label: "出车费用", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "message", label: "信息费", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "allrepair", label: "维修费用", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "allfixed", label: "固定费用", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "alloil", label: "总油费", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "kuitotal", label: "亏吨金额", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "profitmoney", label: "奖金", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "compen", label: "补差金额", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "ingroprofit", label: "毛利润", align: 'right', className: 'pr30', minwidth: 120 },
        { prop: "inprofit", label: "净利润", align: 'right', className: 'pr30', minwidth: 120 },
      ],
      getTotalProperty: [
        'basemoney',
        'infreight',
        'escort',
        'gomoney',
        'message',
        'allrepair',
        'unattendance',
        'allfixed',
        'alloil',
        'compen',
        'profit',
        'groprofit',
        'profitmoney',
        'kuitotal',
        'ingroprofit',
        'inprofit',
      ],
      btns: [
        {
          title: '查看当月订单',
          img: require('@/assets/img/icon_order.png'),
          unimg: require('@/assets/img/icon_order_hover.png'),
          cb: ({ month, license }) => {
            this.$router.push(
              `/finance/monthorder?month=${month}&license=${license}`
            );
          },
        },
        {
          title: '查看当月维修记录',
          img: require('@/assets/img/icon_maintenance.png'),
          unimg: require('@/assets/img/icon_maintenance_hover.png'),
          cb: ({ month, license }) => {
            this.$router.push(
              `/finance/monthfixrecord?month=${month}&license=${license}`
            );
          },
        },
      ],
      baseParams: ['fleet', 'month'],
      title: '车辆预计利润生成',
      modalSearchForm: {},
      modalSearchFormCtrl: [
        {
          label: "月份选择：",
          keyName: "month",
          type: "select",
          options: []
        },
      ],
      modalList: [],
      checkedIds: [],
      checkAll: false,
      isIndeterminate: false,
      fleetName: '',
    };
  },
  methods: {
    getFleet() {
      this.loading = true
      this.tabData = [];
      let url = `${this.baseUrl}/getfleet`;
      const params = {
        // userid: this.user.id,
      }
      // console.log(url, params)
      this.post(url, params, ({ team }) => {
        this.loading = false
        // console.log('team', team)
        this.team = team
        if (team && team.length) {
          this.tabData = team.map((v, i) => {
            return {
              name: i + '',
              label: v.nickname + '队长',
              data: v,
            }
          })
        }
        this.setParams(0)
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    onToggleTab({ index }) {
      this.tabIdx = index;
      this.formInline.month = this.LAST_MONTH
      // console.log(this.tabIdx, index)
      this.setParams(index)
    },
    setParams(idx) {
      // console.log({...this.team[idx]})
      const team = this.team
      this.fleetName = team[idx].nickname
      this.formInline.fleet = team[idx].id
      this.modalSearchForm.fleet = team[idx].id
      this.getOptions({ fleet: this.formInline.fleet })
      this.$nextTick(this.getList);
    },
    setOptions({ month, car }) {
      this.modalSearchFormCtrl[0].options = month.map(v => {
        return {
          label: v,
          value: v,
        }
      })
      this.modalSearchForm.month = month[0]

      this.modalList = [...car]
    },
    generatProfit() {
      this.showDialog()
    },
    onModalSearchFormChange({ key, value }) {
      // console.log(key, value)
      this.modalSearchForm[key] = value;
      this.modalSearchReq()
      console.log({ ...this.modalSearchForm })
    },
    modalSearchReq() {
      this.post(`${this.baseUrl}/updatemonth`, this.modalSearchForm, ({ car }) => {
        this.modalList = [...car]
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '获取数据失败，请稍后重试！'
        });
      })
    },
    handleCheckAllChange(val) {
      const arr = this.modalList.map(v => v.license)
      // console.log(val)
      this.checkedIds = val ? arr : [];
      this.isIndeterminate = false;
    },
    onCheckChange(v) {
      // console.log(v)
      // console.log(this.checkedIds)
      let n = v.length
      this.checkAll = n === this.modalList.length
      this.isIndeterminate = n > 0 && n < this.modalList.length
    },
    onModalSubmit() {
      if (!this.checkedIds.length) {
        this.$message({
          type: 'warning',
          message: '请至少选择1辆车!',
        });
        return
      }
      this.loading = true
      let url = `${this.baseUrl}/addedu`;
      const params = {
        userid: this.user.id,
        ...this.modalSearchForm,
        license: this.checkedIds,
      }

      params['headers'] = {
        'X-Method': 'create',
        'X-Module': 'fleet_profit',
      }

      console.log(url, { ...params })

      this.post(url, params, ({ msg }) => {
        if (msg === 'success') {
          this.$message({
            type: 'success',
            message: '提交成功!',
          });
          this.getList()
          this.hideDialog()
        } else {
          this.$message({
            type: 'error',
            message: msg,
          });
        }
        this.loading = false
      }, err => {
        console.log(err)
        this.$message({
          type: 'error',
          message: '提交失败，请稍后重试！'
        });
      })
    },
    dialogClosed() {
      this.checkedIds = []
      this.checkAll = false
      this.isIndeterminate = false
    },
  },
  created() {
    this.MONTH = this.LAST_MONTH
    this.$set(this.formInline, 'month', this.LAST_MONTH)
  },
  mounted() {
    this.getFleet()
  },
};
</script>

<style lang="less" scoped>
/deep/ .tab-page {
  .el-tabs__header.is-top {
    padding: 0;

    .el-tabs__nav-wrap {
      .el-tabs__active-bar {
        display: none;
      }

      .el-tabs__item {
        width: auto;
        height: 36px;
        line-height: 36px;
        font-size: 16px;
        border-bottom-width: 3px;
        margin: 0 10px;
        padding: 0 20px;
        box-sizing: border-box;
        font-weight: normal;
        transition: border-color .3s, background-color .3s, color .3s;

        &.is-active {
          border-bottom: 3px solid #409eff;
        }
      }
    }
  }
}

.dialog {
  /deep/ .el-dialog {
    width: 90%;
    height: 547px;

    .el-dialog__body {
      padding: 11px 20px 30px;

    }
  }

  .content-h {
    height: 350px;
    overflow-x: hidden;

    /deep/ .el-scrollbar__wrap {
      overflow-x: hidden;
    }

    /deep/ .is-horizontal {
      display: none;
    }
  }

  .searchForm {
    display: flex;

    .checkAll {
      padding: 10px 30px 10px 0px;
    }

    /deep/ .el-form-item {
      .el-form-item__content {
        .el-input {
          input {
            background: #F2F6FC;
          }
        }
      }

      &:not(:first-of-type) {
        margin-left: 15px;
      }
    }
  }

  .list {
    display: flex;
    flex-wrap: wrap;
    // line-height: 20px;

    .item {
      position: relative;
      width: 137px;
      height: 78px;
      //line-height: 24px;
      //padding: 10px;
      margin: 0 15px 15px 0;
      border: 1px solid #E2E6F0;
      border-radius: 6px;
      color: #000;
      font-size: 14px;
      background-color: #FAFAFA;

      // &:nth-child(4n) {
      //   margin-right: 0;
      // }

      &.is-checked {
        border-color: #2691FF;
      }

      /deep/ .el-checkbox__input {
        //display: none;
        position: absolute;
        right: 15px;
        bottom: 8px;
      }

      /deep/ .el-checkbox__label {
        padding: 0;
        width: 100%;
      }

      // .row0 {
      //   display: flex;
      //   margin: 5px 0;
      // }
      .basic {
        height: 43px;
        line-height: 43px;
        overflow: hidden;
        margin: 0 auto;
        padding: 0 15px;
        border-bottom: 1px solid #EBEEF5;

        span:first-child {
          font-size: 14px;
          color: #303133;
        }

        span:nth-child(2) {
          margin-left: 5px;
          font-size: 14px;
          color: #909399;
        }
      }

      .sel {
        height: 34px;
        line-height: 34px;
        overflow: hidden;
        margin: 0 auto;
        padding: 0 15px;

        input {
          width: 18px;
          text-align: center;
        }
      }

      .row1 {
        margin-top: 10px;
        line-height: 24px;

        .content {
          display: block;
          border-bottom: 1px solid #e6e6e6;

          input {
            width: 100%;
            padding: 8px 30px 10px 10px;
            box-sizing: border-box;
          }

          .unit {
            display: inline-block;
            margin-left: -30px;
          }
        }
      }
    }
  }

  .btns {
    margin: 0;
    text-align: center;
    //margin-top: 30px;
  }
}

/deep/ .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #303133;
}
</style>
